export default __webpack_public_path__ + "static/media/outside.7fb86a6f.png";